import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { MonthProvider } from './contexts/MonthContext';
import Login from './pages/Login';
import Budget from './pages/Budget';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';

// Protected Route component
const ProtectedRoute = ({ children }) => {
 const { user, loading } = useAuth();
 
 if (loading) {
 return (
 <div className="min-h-screen flex items-center justify-center bg-background">
   <span className="text-xs font-mono uppercase tracking-widest text-foreground flex items-center gap-0.5">LOADING<span className="cursor-blink inline-block w-[7px] h-[13px] bg-foreground" /></span>
 </div>
 );
 }
 
 if (!user) {
 return <Navigate to="/login" replace />;
 }
 
 return children;
};

function App() {
 return (
 <ErrorBoundary>
 <AuthProvider>
 <MonthProvider>
 <Router>
 <Routes>
 <Route path="/login" element={<Login />} />
 <Route
 path="/"
 element={
 <ProtectedRoute>
 <Layout />
 </ProtectedRoute>
 }
 >
 <Route index element={<Budget />} />
 </Route>
 </Routes>
 </Router>
 </MonthProvider>
 </AuthProvider>
 </ErrorBoundary>
 );
}

export default App;

